var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container"},[_c('div',[_c('img',{staticClass:"progress-circle",attrs:{"src":_vm.$client.loading}}),_c('div',{staticClass:"loading-message"},[_vm._v("접속 정보를 확인 중 입니다")])])])}
var staticRenderFns = []

export { render, staticRenderFns }